//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../no/Builder.js";
let d=[[[0,"AirTrapOption",1,0],[0,"FolderBrowser",1,0],[0,"NumberIntervals",1,0],[0,"NumberSubMeshes",1,0],[0,"ResultsOption",1,0],[0,"WeldLineOption",1,0]],[[[],"DisplayDynamicColorPlots",{},0,0]],[]];
SPLM.Tooling.FlowDisplayBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.FlowDisplayBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.FlowDisplayBuilder.AnalysisResults = Object.freeze({
    "MeltFrontTime" : "MeltFrontTime", "GateContribution" : "GateContribution", "PressureDrop" : "PressureDrop", "MeltFrontTemperature" : "MeltFrontTemperature", "MaxTemperature" : "MaxTemperature", "AverageTemperature" : "AverageTemperature", "FrozenLayerRatio" : "FrozenLayerRatio", "MaxCoolingTime" : "MaxCoolingTime"});

export default SPLM;